"use client";

import type { ReactNode } from "react";
import { usePathname } from "next/navigation";
import clsx from "clsx";

export default function SiteFrame({
  children,
  banner,
  navigation,
  commandMenu,
  footer,
  bannerEnabled,
}: {
  children: ReactNode;
  banner: ReactNode;
  navigation: ReactNode;
  commandMenu: ReactNode;
  footer: ReactNode;
  bannerEnabled: boolean;
}) {
  const pathname = usePathname().replace(/\/+$/, "");
  const standalone = ["/darkplane/one-pager", "/agent0/one-pager", "/observability/one-pager"].includes(pathname);

  return (
    <div className={clsx(!standalone && bannerEnabled && "pt-12!")}>
      {!standalone && banner}
      {!standalone && navigation}
      {!standalone && commandMenu}
      <main className={clsx(
        "layout-base gap-y-32 md:gap-y-40 px-4 md:px-10 max-w-[1728px] mx-auto",
        !standalone && "mt-16 md:mt-18",
      )}>
        {children}
      </main>
      {!standalone && footer}
    </div>
  );
}
